import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class BSPReport {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  iata!: string;
  @IsString()
  @Expose()
  period!: string;
}

export class BSPReportResponse extends GenericTableResponse<BSPReport> {
  @Expose()
  @IsArray()
  @Type(() => BSPReport)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BSPTicket>;
}
